export enum ACCOMODATION_IMAGE_TYPE {

    IMAGE_COVER_DESKTOP = "accomodation_image_desktop",
    IMAGE_COVER_MOBILE = "accomodation_image_mobile",
    IMAGE_LOGO = "accomodation_image_logo"

}